import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Events, Content, LoadingController, ToastController } from 'ionic-angular';
import { AreaAdmin } from '../../models/area';
import { ConversaArea } from '../shared/conversa/conversa-area';
import { MensagemProvider } from '../../providers/mensagem/mensagem';
import { EmpresaLocalProvider } from '../../providers/empresa-local/empresa-local';
import { Mensagem, ArquivoMensagem } from '../../models/mensagem';
import { BrComService } from '../../service/BrComService';
import { FotoProvider } from '../../providers/foto/foto';
import { AreaProvider } from '../../providers/area/area';
import { AreaAdminLocalProvider } from '../../providers/area-admin-local/area-admin-local';
import { ConversaAreaUsuarioPage } from '../conversa-area-usuario/conversa-area-usuario';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';

@IonicPage()
@Component({
  selector: 'page-conversa-area-geral',
  templateUrl: 'conversa-area-geral.html',
})
export class ConversaAreaGeralPage extends ConversaArea {

  @ViewChild(Content) content: Content;
  public areaAdmin: AreaAdmin;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private events: Events,
    private areaProvider: AreaProvider,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
    private changeDetectorRef: ChangeDetectorRef,
    private loadingController: LoadingController,
    private toastController: ToastController,
    private navProxy: NavProxyProvider,
    brComService: BrComService,
    mensagemProvider: MensagemProvider,
    fotoProvider: FotoProvider,
    empresaLocalProvider: EmpresaLocalProvider) {
    super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    this.areaAdmin = this.navParams.get('areaAdmin');
    this.events.subscribe(`msg.area.${this.areaAdmin.idArea}.geral`, (mensagem) => {
      this.areaAdmin.mensagensGerais.push(mensagem);
      // por algum motivo a tela não atualiza como no caso do adicionarNovaMensagem
      // talvez naquele caso, com teclado aberto, outro componentechame a atualização e pegue a mensagem?
      this.changeDetectorRef.detectChanges();
      this.scrollBottom(this.content);
      this.notificarMensagemLida();
    });
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.content.scrollToBottom(0);
    }, 50);
    this.brComService.confirmaUsuarioLogado(this.empresa.CodEmpresa, this.empresa.CodUsuario);
    this.notificarMensagemLida();
  }

  ionViewWillLeave() {
    this.events.unsubscribe(`msg.area.${this.areaAdmin.idArea}.geral`);
    this.areaAdminLocalProvider.removerMensagensGeraisAcimaDoLimite(this.areaAdmin.idArea);
  }

  private adicionarNovaMensagem(msg: Mensagem): void {
    if (!this.areaAdmin.mensagensGerais) {
      this.areaAdmin.mensagensGerais = [];
    }
    this.areaAdmin.mensagensGerais.push(msg);
    this.changeDetectorRef.detectChanges();
    this.scrollBottom(this.content);
    this.areaAdminLocalProvider.adicionarNovaMensagemGeral(this.areaAdmin.idArea, msg);
  }

  private atualizarMensagemComFalhaNoEnvio(msg: Mensagem) {
    this.areaAdmin.mensagensGerais.find(m => m.idEnvio === msg.idEnvio ).falhaNoEnvio = true;
    this.changeDetectorRef.detectChanges();
    this.areaAdminLocalProvider.atualizarMensagemGeral(this.areaAdmin.idArea, msg);
  }

  private notificarMensagemLida(): void {
    if (this.hasMensagensNaoLidas()) {
      this.areaAdminLocalProvider.marcarMensagensGeraisLidas(this.areaAdmin.idArea);
      this.areaProvider.notificarMensagensAreaAdminGeralLidas(this.empresa.IdUsuario, this.brComService.getIdDevice(), this.areaAdmin.idArea).subscribe();
    }
  }

  private hasMensagensNaoLidas(): boolean {
    const result = this.areaAdmin.mensagensGerais.find(m => m.origem === "L" && !m.statusMensagemLida)
    if (result) {
      return true;
    }
    return false;
  }

  public enviarMensagem(mensagem: string): void {
    if (mensagem.trim() !== "") {
      const idUsuarioDestino = 0;
      const msg = this.criarMensagemSimplesEnvio(mensagem, idUsuarioDestino);
      this.adicionarNovaMensagem(msg);
      this.enviarMensagemAdminArea(msg);
    }
  }

  private enviarMensagemAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemSimplesAdminArea(this.empresa.IdUsuario, this.areaAdmin.idArea, this.brComService.getIdDevice(), msg.mensagem).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemGeralEnviada(this.areaAdmin.idArea, msg.idEnvio, idEnvio);
        this.areaAdmin.mensagensGerais.find(m => m.idEnvio === msg.idEnvio ).idEnvio = idEnvio;
      //  this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    )
  }

  public async enviarArquivo(file: File): Promise<void> {
    const arquivo: ArquivoMensagem = {
      nome: file.name,
      mime: file.type,
      link: ""
    }
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemArquivoEnvio(idUsuarioDestino, arquivo);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(file).then(
      url => {
        msg.arquivo.link = url;
        this.areaAdminLocalProvider.atualizarMensagemGeral(this.areaAdmin.idArea, msg);
        const i = this.areaAdmin.mensagensGerais.findIndex(m => m.idEnvio === msg.idEnvio );
        this.areaAdmin.mensagensGerais[i] = msg;
      //  this.areaAdmin.mensagensGerais.push(msg);
       // this.scrollBottom(this.content);
        this.enviarMensagemArquivoAdminArea(msg);
      }, error => {
        console.log(error);
      }
    );
  }

  private enviarMensagemArquivoAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemArquivoAdminArea(this.empresa.IdUsuario, this.areaAdmin.idArea, this.brComService.getIdDevice(), msg.arquivo).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemGeralEnviada(this.areaAdmin.idArea, msg.idEnvio, idEnvio);
        this.areaAdmin.mensagensGerais.find(m => m.idEnvio === msg.idEnvio ).idEnvio = idEnvio;
       // this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    );
  }

  public enviarImagem(imagem: File): void {
    const idUsuarioDestino = 0;
    const msg = this.criarMensagemImagemEnvio(idUsuarioDestino);
    this.adicionarNovaMensagem(msg);
    this.mensagemProvider.uploadFirebase(imagem).then(
      url => {
        msg.link = url;
        this.areaAdminLocalProvider.atualizarMensagemGeral(this.areaAdmin.idArea, msg);
        const i = this.areaAdmin.mensagensGerais.findIndex(m => m.idEnvio === msg.idEnvio );
        this.areaAdmin.mensagensGerais[i] = msg;
        this.enviarMensagemImagemAdminArea(msg);
      }, error => {
        console.log(error)
      }
    )
  }

  public async responderUsuario(m: Mensagem): Promise<void> {
    if (m.podeSerRespondida) {
      const loading = this.loadingController.create({
        content: 'Aguarde...'
      });
      await loading.present();
      const view = this.navCtrl.getActive();
      const conversaUsuario = this.areaAdminLocalProvider.getConversaUsuario(this.areaAdmin.idArea, m.idUsuarioOrigem);
      if (conversaUsuario) {
        this.navProxy.pushContent(ConversaAreaUsuarioPage, {
          conversaUsuario: conversaUsuario,
          idArea: this.areaAdmin.idArea
        })
        loading.dismiss();
      } else {
        this.areaProvider.getConversaUsuario(m.idUsuarioOrigem, this.areaAdmin.idArea).subscribe(
          async conversaUsuario => {
            this.areaAdminLocalProvider.adicionarConversaUsuario(this.areaAdmin.idArea, conversaUsuario);
            await this.navCtrl.push(ConversaAreaUsuarioPage, {
              conversaUsuario: conversaUsuario,
              idArea: this.areaAdmin.idArea
            });
            this.navCtrl.removeView(view);
          }, () => {
            this.toastController.create({
              message: 'Ocorreu um erro inesperado.',
              duration: 3000
            }).present();
          }
        );
      }
    }
  }


  private enviarMensagemImagemAdminArea(msg: Mensagem): void {
    this.areaProvider.enviarMensagemImagemAdminArea(this.empresa.IdUsuario, this.areaAdmin.idArea, this.brComService.getIdDevice(), msg.link).subscribe(
      (idEnvio: number) => {
        this.areaAdminLocalProvider.atualizarMensagemGeralEnviada(this.areaAdmin.idArea, msg.idEnvio, idEnvio);
        this.areaAdmin.mensagensGerais.find(m => m.idEnvio === msg.idEnvio ).idEnvio = idEnvio;
//        this.atualizaListaMensagens();
      }, (error) => {
        this.atualizarMensagemComFalhaNoEnvio(msg);
      }
    );
  }

  public trackBy(index: number, msg: Mensagem): any {
    return  index;
}
}



// WEBPACK FOOTER //
// ./src/pages/conversa-area-geral/conversa-area-geral.ts